<template>
  <div>
    <el-carousel height="410px" class="swImg" arrow="never">
      <el-carousel-item v-for="(item, index) in imgList" :key="index" class="pointer">
        <img style="height: 100%" :src="item.img" @click="nav(item)" />
      </el-carousel-item>
    </el-carousel>

    <div class="sidebar">
      <div class="s_left">
        <div class="lz">{{uName}}</div>

       <div @click="cho(item)" v-for="(item, index) in dList" :key="index" :class="dname == item ? 'ttl cho' : 'ttl'">
          <div class="ttl_l"></div>
          <div class="n">{{item}}</div>
          <img v-if="dname == item" src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x34.png" alt="" />
        </div>
      </div>

      <div class="s_r">
        <div class="z_l">
          <div></div>
          {{ dname }}
        </div>
        <div class="llll"></div>

        <div class="z" >
          <div class="z_til elp">{{ newsList.title }}</div>
          <div class="z_tils ">
            <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x36.png" alt="">
            {{ newsList.addTime.slice(0,16) }}</div>
           <div v-html="newsList.content"></div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { Know } from "@/api/know";
const know = new Know();
import { queryAllArticle } from "@/api/home";
import { DataClient } from "@/api/dataClient";
const dataClient = new DataClient();
import { getSurfaceList } from "@/api/home";
import { getDomain } from "@/api/cookies";
import { queryAllArticleid } from "@/api/home";

export default {
  name: "NewsDynamic",
  data() {
    return { 
      dindex: 1,
      dname: "学校介绍",
      uuc: 10,

  newsList:{}
    };
  },
  created() {
    this.infoDomain = getDomain();
      this.uName = this.$route.query.uName
     if (this.$route.query.uName == '学校概况') {
      this.uuc = 10
      this.dList = ["学校介绍", "基地介绍", "校园风光"]
    } else if (this.$route.query.uName == '招生简章') {
      this.uuc = 13

      this.dList = ["招生简章"]
    } else if (this.$route.query.uName == '项目介绍') {
      this.uuc = 14

      this.dList = ["项目背景", "项目简介", "办学优势"]
    } else if (this.$route.query.uName == '报考指南') {
      this.uuc = 17

      this.dList = ["报名流程", "招生问答", "录取查询"]
    } else if (this.$route.query.uName == '新闻资讯') {
      this.uuc = 11

      this.dList = ["院校新闻", "通知公告", "招生问答", "报考指南", "校内通知", "自考备考", "自考政策"]
    }
      if (this.$route.query.dname) {
      this.dname = this.$route.query.dname
    } else {
      this.dname = this.dList[0]
    }
    this.getList();
   
  },
  methods: {
     cho(i) {
      this.$router.push({
        path: `/xqxx`,
        query: {
          uName: this.uName,
          dname: i
        }
      })
     
    },
 
    async getList() {
      getSurfaceList(this.uuc, undefined, this.infoDomain.entrantsType).then(
        (ress) => {
          if (ress.code == 0) {
            this.imgList = JSON.parse(JSON.stringify(ress.msg));
          }
        }
      );
       queryAllArticleid(this.$route.query.id).then((res) => {
        this.newsList = res.data;
      });

    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  width: 1200px;
  min-height: 920px;

  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: 24px;

  .s_left {
    width: 300px;
    height: fit-content;
    background: #f5fcff;
    border-radius: 0px 0px 0px 0px;
    position: sticky;
    /* 距离顶部 0 像素时固定 */
    top: 140px;
    /* 确保元素显示在其他内容上方 */
    z-index: 9;

    .lz {
      width: 300px;
      height: 74px;
      background: linear-gradient(91deg, #0073ff 0%, #0057c9 100%);
      border-radius: 0px 0px 0px 0px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 24px;
      color: #ffffff;
      line-height: 74px;
      padding-left: 31px;
    }

    .lll {
      width: 219px;
      height: 0px;
      border: 1px solid #64a4f3;
      margin-top: 24px;
    }

    .ttl {
      width: 300px;
      height: 69px;
      background: #f5fcff;
      border-radius: 0px 0px 0px 0px;
      display: flex;
      align-items: center;
      padding-right: 28px;
      cursor: pointer;

      .ttl_l {
        width: 3px;
        height: 69px;
        
        background: #6ac5ff;

        border-radius: 0px 0px 0px 0px;
      }

      .n {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        margin-left: 28px;
        flex: 1;
      }

      img {
        width: 24px;
        flex-shrink: 0;
      }
    }

    .cho {
      background: #ffffff;

      .ttl_l {
        background: #2080f7;
      }

      .n {
        color: #0074ef;
      }
    }
  }

  .s_r {
    width: 852px;

    .z_l {
      display: flex;
      align-items: center;

      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 20px;
      color: #0074ef;

      div {
        width: 15px;
        height: 15px;
        background: linear-gradient(180deg, #0073ff 0%, #0057c9 100%);
        border-radius: 2px 2px 2px 2px;
        margin-right: 8px;
      }
    }

    .llll {
      width: 100%;
      height: 2px;
      background: #0074ef;
      border-radius: 0px 0px 0px 0px;
      margin-top: 12px;
      margin-bottom: 20px;
    }

    .z {
      padding: 24px;
      background: #ffffff;
      border-radius: 12px 12px 12px 12px;
 .z_til{ 
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: bold;
font-size: 20px;
color: #333333; 
 }
 .z_tils{ 
  width: fit-content;
height: 24px;
background: #FFF1E9;
border-radius: 4px 4px 4px 4px;
display: flex;
align-items: center;
justify-content: center; 
font-family: MiSans, MiSans;
font-weight: 500;
font-size: 12px;
color: #FF580D; 
margin-top: 16px;
margin-bottom: 20px;
padding: 0 8px;
img{
  width: 12px;
  margin-right: 6px;
}
 }
      
    }
  }
}

.swImg {
  img {
    width: 100%;
  }
}
</style>
